import { jsx as _jsx } from "react/jsx-runtime";
import Lottie from "lottie-react";
import dotsAnimation from "@carousel-office/shared-assets/dots.json";
import { CheckmarkIcon, WarningIcon } from "../../icons";
/**
 * Status indicator for tool cards.
 * Uses loading dots and plain status glyphs.
 */
export const ToolStatusIndicator = ({ status }) => {
    const isLoading = status === "streaming" || status === "calling" || status === "running" || status === "starting";
    const isSuccess = status === "complete";
    const isWarning = status === "error" || status === "stopped";
    if (isLoading) {
        return (_jsx("div", { className: "inline-block w-[14px] h-[14px] shrink-0", "aria-hidden": "true", children: _jsx(Lottie, { animationData: dotsAnimation, loop: true, autoplay: true, style: { width: 14, height: 14 } }) }));
    }
    if (isSuccess) {
        return (_jsx("div", { className: "inline-flex w-[14px] h-[14px] shrink-0 items-center justify-center text-green-60", "aria-hidden": "true", children: _jsx(CheckmarkIcon, { size: 12, color: "currentColor" }) }));
    }
    if (isWarning) {
        return (_jsx("div", { className: "inline-flex w-[14px] h-[14px] shrink-0 items-center justify-center text-yellow-60", "aria-hidden": "true", children: _jsx(WarningIcon, { size: 12 }) }));
    }
    return null;
};
